<template>
<div class="workStatistics">
  <p class="title">班级作业报告</p>
  <div class="contentReport">
    <rankHeader :classList="classList" :className="className" @changClassId="changClassId" 
    :startDate="startDate" :endDate="endDate" @changedPicker="changedPicker" @getWorkStatistics="getWorkStatistics">
    </rankHeader>
    <div class="dataBox">
      <div class="basicInfo">
        <span class="tip">基本情况</span>
        <table>
         <tr>
           <th>布置作业次数</th>
           <th>平均提交率</th>
           <th>平均作业时长</th>
           <th>
            平均成绩
            <el-popover placement="bottom" width="200" trigger="hover" content="一段时间内，班级平均得分，换算成百分制。">
                <i class="iconQMark" slot="reference"></i>
            </el-popover>
           </th>
         </tr>
         <tr>
           <td>{{classBaseInfo.assignNum}}</td>
           <td>{{classBaseInfo.avgFinishRate | toPercent(2, '-')}}</td>
           <td>{{classBaseInfo.avgWorkTime | secTotime1}}</td>
           <td>{{classBaseInfo.score}}</td>
         </tr>
        </table>
      </div>
      <echartLine :echartData="echartData" @setsoreType="setsoreType"></echartLine>
      <reportTable :userList="userList" :worklist="workList" :url="exportUrl"></reportTable>
      <scoreTable :scoreData="scoreData" :url="exportClassWorkUrl" @setPage="setPage"></scoreTable>
    </div>
  </div>
</div>
</template>
<script>
import fetch from "./../fetch";
import { brandId, http, clientId} from "./../config";
import rankHeader from "./../components/reportTable/header.vue";
import echartLine from "./../components/reportTable/echartLine.vue";
import reportTable from "./../components/reportTable/reportTable.vue";
import scoreTable from "./../components/reportTable/scoreTable.vue";
export default {
  data() {
    return {
      classList: [],
      classId: '',
      className: '',
      startDate: '',
      endDate: '',
      exportClassWorkUrl: '',
      exportUrl: '',
      workList: [],
      userList: [],
      classBaseInfo: {},
      echartData: [],
      scoreData: [],
      page: 1
    };
  },
  components: {
    reportTable,
    rankHeader,
    echartLine,
    scoreTable
  },
  created() {
    this.$nextTick(() => {
      let classList = window.sessionStorage.getItem('studentsListData')
      this.classList = classList ? JSON.parse(classList) : []
      if (!this.classList.length) {
        return false
      }
      this.classId = this.classList[0].classId
      this.className = this.classList[0].className
      this.setInitTime()
      this.getWorkStatistics()
    })
  },
  methods: {
    setInitTime() {
      let nowdate = new Date()
      let y = nowdate.getFullYear();
      let m = nowdate.getMonth();
      let d = nowdate.getDate();
      let formatwdate = y + '-' + m + '-' + (d - 1) + ' 23:59:59';
      let maxTime = y + '-' + (m + 1) + '-' + (d - 1) + ' 23:59:59';
      this.endDate = Date.parse(maxTime)
      this.startDate = Date.parse(formatwdate)
    },
    changedPicker (data) {
      this.startDate = data.startDate
      this.endDate = data.endDate
    },
    getWorkStatistics () {
      if (this.endDate - this.startDate > 2678400000) {
          this.$toast('统计报告时间段最长选择1个月（31天）', 'error')
          return false
      }
      let data = {
        classId: this.classId,
        className: this.className,
        startDate: Math.floor(this.startDate / 1000),
        endDate: Math.floor(this.endDate / 1000),
      }
      fetch.getClassWorkStatistics(data).then(res => {
        if (!res.data) {
          return false
        }
        this.workList = res.data.workList
        this.userList = res.data.userList
        this.exportWorkStatistics(data)
      })
      this.getclassBaseInfo()
      this.setsoreType(0)
      this.setClassWorkReport()
    },
    setClassWorkReport () {
      let params = {
        classId: this.classId,
        className: this.className,
        startDate: Math.floor(this.startDate / 1000),
        endDate: Math.floor(this.endDate / 1000),
        page: this.page,
        pageSize: 5
      }
      fetch.getClassWorkReport(params).then(res => {
        if (!res) {
          return false
        }
        this.scoreData = res.data
      })
      this.exportClassWorkUrl = http + '/gateway/v1/epaperstatistics/exportClassWorkReport?clientId=' + clientId + '&classId=' + this.classId + '&className=' 
      + this.className + '&startDate=' + Math.floor(this.startDate / 1000) + '&endDate=' + Math.floor(this.endDate / 1000) + '&page=' + this.page + '&pageSize=' + 5
    },
    exportWorkStatistics () {
      this.exportUrl = http + '/gateway/v1/epaperstatistics/exportClassWorkStatistics?clientId='+ clientId +'&classId=' + this.classId + '&className=' + this.className + '&startDate='+ Math.floor(this.startDate / 1000)+'&endDate='+  Math.floor(this.endDate / 1000)
    },
    changClassId (data) {
      this.classId = data.classId
      this.className = data.className
    },
    setPage (val) {
      this.page = val
      this.setClassWorkReport()
    },
    getclassBaseInfo () {
      let params = {
        classId: this.classId,
        begin: Math.floor(this.startDate / 1000),
        end: Math.floor(this.endDate / 1000)
      }
      fetch.getClassBaseInfo(params).then(res => {
        if (!res) {
          return false
        }
        this.classBaseInfo = res.data
      })
    },
    setsoreType (data) {
      let params = {
        classId: this.classId,
        soreType: data,
        begin: Math.floor(this.startDate / 1000),
        end: Math.floor(this.endDate / 1000)
      }
      fetch.getclasssoreline(params).then(res => {
        if (!res || !res.data) {
          return false
        }
        this.echartData = res.data
      })
    }
  }
};
</script>



// WEBPACK FOOTER //
// classReport.vue?c5f06d3a